<template>
    <m-form ref="form">
        <template #content>
            <v-layout wrap row justify-end>
                <v-flex xs12>
                    <e-input-user-password v-model="form.password"
                                           :label="$t('modules.forms.m-form-user-change-password.inputs.password')"
                                           name="password"
                                           rules="required"
                                           ref="password"/>
                </v-flex>
                <v-flex xs12>
                    <e-input-user-password v-model="form.newPassword"
                                           :label="$t('modules.forms.m-form-user-change-password.inputs.new-password')"
                                           rules="required|min:8|max:64|password"
                                           name="newPassword"
                                           ref="newPassword"
                                           :tooltip="passwordTooltipText"
                                           :innerTooltip="breakpoints.isLessThanTablet"
                    />
                </v-flex>
                <v-flex xs12>
                    <e-input-user-password-confirmation v-model="form.passwordConfirmation"
                                                        name="passwordConfirmation"
                                                        :label="$t('modules.forms.m-form-user-change-password.inputs.new-password-confirmation')"
                                                        :parentRefs="$refs"
                                                        passKey="newPassword"
                                                        :tooltip="passwordTooltipText"
                                                        :innerTooltip="breakpoints.isLessThanTablet"
                    />
                </v-flex>
            </v-layout>
        </template>

        <template #buttons>
            <m-block-form-buttons :isLoading="$wait.waiting(keys.auth.change_password)"
                                  :showCancelButton="false"
                                  :text="text"
                                  @cancel="cancel"
                                  @submit="submit"/>
        </template>
    </m-form>
</template>

<script>
    import MForm from "@modules/forms/m-form";
    import MBlockFormButtons from "@modules/blocks/buttons/concrete/m-block-form-buttons";

    import vuexKeys from '@mixins/includes/_vuexKeys'
    import notifications from "@mixins/includes/_notifications";
    import errorHandler from "@mixins/responses/_errorHandler";

    import {createNamespacedHelpers} from 'vuex';

    const {mapActions} = createNamespacedHelpers('auth');

    export default {
        name: 'm-form-profile-change-password',
        components: {MForm, MBlockFormButtons},
        mixins: [vuexKeys, notifications, errorHandler],
        $_veeValidate: {
            validator: 'new'
        },

        beforeDestroy() {
            this.reset();
        },
        data: () => ({
            form: {
                password: null,
                newPassword: null,
                passwordConfirmation: null
            }
        }),
        computed: {
            text() {
                return {
                    submit: this.$t('modules.forms.m-form-user-change-password.buttons.submit')
                }
            },
            passwordTooltipText() {
                return this.$t('modules.forms.m-form-user-change-password.tooltips.password');
            }
        },
        methods: {
            ...mapActions(['change_password']),

            submit() {
                this.$validator.validateAll().then((success) => {
                    if (success) {
                        this.request();
                    } else {
                        const el = document.querySelector(".v-messages__message");
                        el.scrollIntoView({behavior: "smooth" ,block: "center"});
                        this.notify.error(this.$t('notifications.errors.formErrors.invalid'));
                    }
                })
            },

            async request() {
                try {
                    await this.change_password({form: this.form});
                } catch (e) {
                    if (e.response && e.response.status === 404) {
                        this.error.handle(e);
                    } else {
                        this.notify.success(this.$t('notifications.profile.changePassword.changed'));
                        setTimeout(()=>{
                            location.reload();
                        },500);
                    }
                }
            },

            cancel() {
                this.$router.go(-1);
            },

            reset() {
                this.$refs.form.reset();
                this.$validator.reset();
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
